export { API_BASE_URL } from "../api/apiClient";

export const ERROR_MESSAGES = {
  user_not_found: "Utente non trovato. Verifica l'indirizzo email inserito.",
  invalid_credentials: "Credenziali non valide.",
  password_mismatch: "Le password non coincidono.",
  weak_password: "La password non rispetta i requisiti minimi.",
  invalid_reset_link: "Il link di reset password non è valido o è scaduto.",
  validation_error: "Errore di validazione. Verifica i dati inseriti.",
  unauthorized: "Non sei autorizzato ad eseguire questa operazione.",
};

const SYSTEM_ERRORS = {
  timeout: "Timeout della richiesta. Riprova più tardi.",
  network: "Errore di connessione. Verifica la tua connessione internet.",
  generic: "Si è verificato un errore. Riprova più tardi.",
};

export const parseApiError = (error, customMessages = {}) => {
  const allMessages = { ...ERROR_MESSAGES, ...customMessages };

  if (error.response?.data?.error) {
    const { localized_error, message } = error.response.data.error;
    const errorKey = localized_error || message;
    return allMessages[errorKey] || errorKey;
  }

  if (error.code === "ECONNABORTED") {
    return SYSTEM_ERRORS.timeout;
  }

  if (!error.response) {
    return SYSTEM_ERRORS.network;
  }

  return SYSTEM_ERRORS.generic;
};

export const defaultAxiosConfig = {
  timeout: 10000,
};

export const validateRequiredParams = (params, required) => {
  const missing = required.filter((key) => !params[key]);
  if (missing.length > 0) {
    throw new Error(`Parametri mancanti: ${missing.join(", ")}`);
  }
};
